
  import * as ipxRuntime$TodelScdPL8d7lSvhKvT_GmOFAqYow_XeTcRsxh1Na8 from '/app/node_modules/.pnpm/@nuxt+image@1.11.0_@capacitor+preferences@7.0.2_@capacitor+core@7.4.2__@netlify+blobs@9_dcaa03ba80c93a9368021ef58c4cedb6/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [
    "dartsspace.com",
    "dartsspace.test"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['ipx']: { provider: ipxRuntime$TodelScdPL8d7lSvhKvT_GmOFAqYow_XeTcRsxh1Na8, defaults: {} }
    }
  }
